import React, { useEffect, useState } from 'react';
import {message, Modal, Select} from 'antd';
import {updateAppointmentStatus} from "../../../api/appointments";
import titleize from "titleize";

const {Option} = Select;

function StatusModal(props) {
    const {
        setStatusModalVisibility,
        isStatusModalVisible,
        id,
        onSuccess
    } = props;

    const [statusValue, setStatusValue] = useState(null);

    const statusList = [
        { value: 'REQUEST_RESCHEDULE', displayText: 'REQUEST RESCHEDULE' },
        { value: 'SCHEDULED', displayText: 'SCHEDULED' },
        { value: 'IN_PROGRESS', displayText: 'IN PROGRESS' },
        { value: 'COMPLETE', displayText: 'COMPLETE' },
        { value: 'CANCELLED', displayText: 'CANCELLED' },
        { value: 'UNCONFIRMED', displayText: 'UNCONFIRMED' },
        { value: 'DECLINED', displayText: 'DECLINED' },
        { value: 'CONFIRMED', displayText: 'CONFIRMED' },
        { value: 'CHECKED_IN_WAITING', displayText: 'CHECKED IN WAITING' },
        { value: 'CALLED_BACK_TO_QUEUE', displayText: 'CALLED BACK TO QUEUE' },
        { value: 'CHECKED_IN', displayText: 'CHECKED IN' },
        { value: 'IN', displayText: 'IN' },
        { value: 'CHECKED_OUT', displayText: 'CHECKED OUT' },
        { value: 'NO_SHOW', displayText: 'NO SHOW' },
        { value: 'START_CONSULT', displayText: 'START CONSULT' },
        { value: 'END_CONSULT', displayText: 'END CONSULT' }
    ];

    useEffect(() => {
        if (!isStatusModalVisible) {
            setStatusValue(null);
        }
    }, [isStatusModalVisible]);

    return (
        <Modal
            title='Change Appointment Status'
            visible={isStatusModalVisible}
            onCancel={() => setStatusModalVisibility(false)}
            destroyOnClose={true}
            cancelText={'Close'}
            okText={'Save Changes'}
            onOk={async () => { // I think this is how it works?
                try {
                    if (statusValue) {
                        await updateAppointmentStatus({
                            id: id,
                            status: statusValue
                        });
                        message.success(`${titleize('Appointment status')} changed.`);
                        if (onSuccess) {
                            onSuccess();
                        }
                        setStatusModalVisibility(false);
                    } else {
                        message.error('Please select a status to continue.');
                    }
                } catch(err) {
                    message.error(err);
                }
            }}
            centered
        >
            <label>Status:</label><br/>
            <Select
                showSearch
                placeholder="Select Status"
                optionFilterProp="children"
                filterOption={(input, option) =>
                    option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                }
                size='large'
                style={{
                    width: '100%',
                }}
                onChange={(value) => setStatusValue(value)}
            >
                {statusList && statusList.length > 0 && statusList.map((status, i) => (
                    <Option key={status.value} value={status.value}>{status.displayText}</Option>
                ))}
            </Select>
        </Modal>
    );
}

export default StatusModal;